import Vue from 'vue/dist/vue.esm'
import axios from './src/plugins/axios'
import vueVimeoPlayer from "vue-vimeo-player";

import SharedVideo       from './src/components/shared/Video'
import SharedMonthReport from './src/components/shared/video/MonthReport'
import SharedDayReport   from './src/components/shared/video/DayReport'

import AdminOrderVideo        from "./src/components/admin/OrderVideo";
import AdminOrderSeries       from "./src/components/admin/OrderSeries";
import AdminOrderSeriesVideo  from "./src/components/admin/series/OrderSeriesVideo";
import AdminOrderPdfSeries    from "./src/components/admin/OrderPdfSeries"
import AdminOrderPdfPdfSeries from "./src/components/admin/pdf_series/OrderPdfPdfSeries"
import AdminCreateSeriesForm  from './src/components/admin/series/CreateSeriesForm'
import AdminUpdateSeriesForm  from './src/components/admin/series/UpdateSeriesForm'
import AdminSeriesChart       from './src/components/admin/series/SeriesChart';

import DashboardOrderVideo        from "./src/components/dashboard/OrderVideo";
import DashboardOrderSeries       from "./src/components/dashboard/OrderSeries";
import DashboardOrderPdfSeries    from "./src/components/dashboard/OrderPdfSeries";
import DashboardOrderSeriesVideo  from "./src/components/dashboard/series/OrderSeriesVideo";
import DashboardOrderPdfPdfSeries from "./src/components/dashboard/pdf_series/OrderPdfPdfSeries";

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'

document.addEventListener('DOMContentLoaded', () => {
  if(!document.querySelector('#vue-app')) return
  Vue.use(axios);
  Vue.use(vueVimeoPlayer)
  Vue.use(ElementUI, { locale })


  const app = new Vue({
    el: "#vue-app",
    components: {
      SharedVideo,
      SharedMonthReport,
      SharedDayReport,
      AdminOrderVideo,
      AdminOrderSeries,
      AdminOrderSeriesVideo,
      AdminOrderPdfSeries,
      AdminOrderPdfPdfSeries,
      AdminCreateSeriesForm,
      AdminUpdateSeriesForm,
      DashboardOrderVideo,
      DashboardOrderSeries,
      DashboardOrderPdfSeries,
      DashboardOrderSeriesVideo,
      DashboardOrderPdfPdfSeries,
      AdminSeriesChart
    }
  })
})
